import { render, staticRenderFns } from "./SignatureIcon.vue?vue&type=template&id=27ff2afa&scoped=true&"
import script from "./SignatureIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SignatureIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ff2afa",
  null
  
)

export default component.exports